import * as actionTypes from 'store/actions/actionTypes';

export const writeQRcode = (products, settings) => ({
  type: actionTypes.WRITE_QRCODE_END,
  products,
  settings,
});

export const clearQRcode = () => {
  return dispatch => {
    return dispatch({
      type: actionTypes.CLEAR_QRCODE_END,
    });
  };
};

export const deleteQRcode = id => {
  return dispatch => {
    return dispatch({
      type: actionTypes.DELETE_QRCODE_END,
      id,
    });
  };
};

// data = previous data
// value = incoming new updated data
export const updateQRcode = (data, value, settings) => dispatch => {
  dispatch({ type: actionTypes.UPDATE_QRCODE_STORE, data, value, settings });
  return 'completed';
};



// WEBPACK FOOTER //
// ./src/store/actions/QRcode.js